<template>
<div id="background" class="">
  <div id = "opacityBackground">
    <v-app-bar 
        color="#DCEDC8"
        prominent
        floating=""
        height="235"
        >
        <v-toolbar-title > 
          <v-spacer></v-spacer> 
          Contáctanos: 987 259 549 | administracion@lg-legitrans.com
        </v-toolbar-title>
    </v-app-bar>  
        
    <!--Menu-->
    <v-card >
      <v-app-bar
        color="#1B5E20"
        dark
        app
        prominent=""
        hide-on-scroll=""
      >
        <!--<v-toolbar-title center><v-img src="./assets/top1.png" max-height="250"></v-img></v-toolbar-title>-->
        <v-img src="./assets/legitrans web/LogoLG2016.png" max-height="120" max-width="256" width="25%"></v-img>
        <v-spacer></v-spacer>
        <v-toolbar-title center class="titulo">
          <div>
            <svg viewBox="-10 -5 300 150">
              <!-- Symbol-->
              <symbol id="s-text">
                <text font-size= "20px" x="50px" y="140px">LEGITRANS, S. L.</text>
              </symbol>
              <!-- Duplicate symbols-->
              <use class="text" xlink:href="#s-text"></use>
              <use class="text" xlink:href="#s-text"></use>
              <use class="text" xlink:href="#s-text"></use>
              <use class="text" xlink:href="#s-text"></use>
              <use class="text" xlink:href="#s-text"></use>
            </svg>
          </div>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-img src="./assets/legitrans web/kisspng-arrow-5d43e475e48c97.4811358315647304859362.png" max-height="125" max-width="125" width="12%"></v-img>
        <!--<v-img src="./assets/legitrans web/unnamed.png" max-height="122" max-width="128"></v-img>-->
        <template v-slot:extension>
          <v-tabs id="tabs" fixed-tabs v-model="activeTab">
            <v-tab id="legitransTab" v-on:click="legitrans()"> Legitrans </v-tab>
            <v-tab v-on:click="servicios()"> Servicios </v-tab>
            <v-tab v-on:click="gestionAmbiental()"> Gestión Ambiental </v-tab>
            <v-tab v-on:click="productos()"> Productos </v-tab>
            <v-tab v-on:click="medios()"> Medios </v-tab>
            <v-tab v-on:click="autorizaciones()"> Autorizaciones </v-tab>
            <v-tab v-on:click="zonaDescarga()"> Zona de descargas </v-tab>
            <v-tab v-on:click="politicaAmbiental()"> Política Medioambiental </v-tab>
            <v-tab v-on:click="contacto()"> Contacto </v-tab>
            <v-tab href="https://legitrans.blogspot.com" target="_blank"> Blog </v-tab>
            <v-tab href="http://www.legitrans.dynu.net/web/cliente/login.asp"> Zona privada </v-tab>
          </v-tabs>
        </template>
      </v-app-bar>
    </v-card>
    <br>
    <br>
    <Banner/>
      <!--Components-->
      <v-main center>
            <div id="legitrans">
                  <Legitrans/>
            </div>
            <div class="comp" id="servicios">
                  <Servicios/>
            </div>
            <div class="comp" id="gestionAmbiental" >
                  <GestionAmbiental/>
            </div>
            <div class="comp" id="productos">
                  <Productos/>
            </div>
            <div class="comp" id="medios">
                  <Medios/>
            </div>
            <div class="comp" id="autorizaciones">
                  <Autorizaciones/>
            </div>
            <div class="comp" id="zonaDescarga" >
                  <ZonaDescarga/>
            </div>
            <div class="comp" id="politicaAmbiental">
                  <PoliticaAmbiental/>
            </div>
            <div class="comp" id="contacto">
                  <Contacto/>
            </div>
      </v-main>
      <!--Footer-->
      <Footer/>
      <!--<v-overlay :value="overlay" >-->
            <v-card
                  class="cookies"
                  color="#DCEDC8"
                  light
                  v-if="overlay"
                  >
                  <v-card-text>
                        Utilizamos cookies propias y de terceros para obtener datos estadísticos de la navegación de nuestros usuarios y mejorar nuestros servicios. Si acepta o continúa navegando, consideramos que acepta su uso.
                  </v-card-text>
                  <div class="wrapper">
                        <div class="column">
                              <a href="http://lg-legitrans.com/descargas/Política%20de%20privacidad%20LEGITRANS,%20S.L..pdf" target="_blank">Política de Privacidad</a>
                        </div>
                        <div class="column">
                              <a href="http://lg-legitrans.com/descargas/Aviso%20Legal%20LEGITRANS,%20S.L..pdf" target="_blank">Aviso legal</a>
                        </div>
                        <div class="column">
                              <v-btn dark color="#1B5E20" @click="overlay = false">Aceptar</v-btn>
                        </div>
                  </div>
            </v-card>
      <!--</v-overlay>-->
      <v-btn class="float" fab dark color="#1B5E20" v-on:click="scrollTop()">
        <v-icon dark>mdi-chevron-up</v-icon>
      </v-btn>
    </div>
  </div>
</template>
<script>
import Legitrans from './components/Legitrans';
import Servicios from './components/Servicios';
import GestionAmbiental from './components/GestionAmbiental';
import PoliticaAmbiental from './components/PoliticaAmbiental';
import Productos from './components/Productos';
import Autorizaciones from './components/Autorizaciones';
import Medios from './components/Medios';
import ZonaDescarga from './components/ZonaDescarga';
import Contacto from './components/Contacto';
import Footer from './components/Footer';
import Banner from './components/Banner'
import data from '@/data/GlobalData';

export default {
  name: 'App',

  components: {
    Legitrans,
    Servicios,
    GestionAmbiental,
    PoliticaAmbiental,
    Productos,
    Autorizaciones,
    Medios,
    ZonaDescarga,
    Contacto,
    Footer,
    Banner
  },

  data () {
    return {
        tab: null,
        numItems: 9,
        items: [
          'Legitrans', 'Servicios', 'Gestión Ambiental', 'Productos', 'Autorizaciones', 'Medios', 'Zona de descargas', 'Contacto' , 'Blog', 'Zona privada'
        ],
        scroll: 0,
        activeTab: data.activeTab,
        backgroundNum:0,
        NumBackgrounds:2, //Min 1
        cookie:true,
        overlay: true,
      }
  },
  created(){
    this.refresh()
    //Fijando el background
    setTimeout(() => {  
        var background = document.getElementById("background").classList
        background.add("background" + this.backgroundNum%this.NumBackgrounds)
        this.backgroundNum++
        if(background%this.NumBackgrounds == 1) this.backgroundNum =1
     }, 100);

    //Cambio de Background
    setInterval(() => {
        var background = document.getElementById("background").classList
        background.remove("background" + (this.backgroundNum-1)%this.NumBackgrounds)
        background.add("background" + this.backgroundNum%this.NumBackgrounds)
        this.backgroundNum++
        if(background%this.NumBackgrounds == 1) this.backgroundNum =1
        //Tiempo entre cambio de background
      }, 600000)

    setInterval(() => {
        if (!this.autorun) return
        if (++this.window >= this.length) this.window = 0
      }, 10000)
    window.addEventListener("scroll", function () {
        if (document.querySelector("#contacto").getBoundingClientRect().top<150) data.activeTab = 8
        else if (document.querySelector("#politicaAmbiental").getBoundingClientRect().top<150) data.activeTab = 7
        else if (document.querySelector("#zonaDescarga").getBoundingClientRect().top<150) data.activeTab = 6
        else if (document.querySelector("#autorizaciones").getBoundingClientRect().top<150) data.activeTab = 5
        else if (document.querySelector("#medios").getBoundingClientRect().top<150) data.activeTab = 4
        else if (document.querySelector("#productos").getBoundingClientRect().top<150) data.activeTab = 3
        else if (document.querySelector("#gestionAmbiental").getBoundingClientRect().top<150) data.activeTab = 2
        else if (document.querySelector("#servicios").getBoundingClientRect().top<150) data.activeTab = 1
        else if(document.querySelector("#legitrans").getBoundingClientRect().top<150) data.activeTab = 0
        console.log(document.getElementById("background").style.backgroundImage)
      });
  },
  methods: {
      legitrans(){
        document.querySelector("#legitrans").scrollIntoView({
          behavior: 'smooth'
        });
      },
      servicios(){
        document.querySelector("#servicios").scrollIntoView({
          behavior: 'smooth'
        });
      },
      gestionAmbiental(){
        document.querySelector("#gestionAmbiental").scrollIntoView({
          behavior: 'smooth'
        });
      },
      politicaAmbiental(){
          document.querySelector("#politicaAmbiental").scrollIntoView({
          behavior: 'smooth'
        });
      },
      productos(){
        document.querySelector("#productos").scrollIntoView({
          behavior: 'smooth'
        });
      },
      autorizaciones(){
        document.querySelector("#autorizaciones").scrollIntoView({
          behavior: 'smooth'
        });
      },
      medios(){
        document.querySelector("#medios").scrollIntoView({
          behavior: 'smooth'
        });
      },
      zonaPrivada(){
        document.querySelector("#zonaPrivada").scrollIntoView({
          behavior: 'smooth'
        });
      },
      zonaDescarga  (){
        document.querySelector("#zonaDescarga").scrollIntoView({
          behavior: 'smooth'
        });
      },
      contacto  (){
        document.querySelector("#contacto").scrollIntoView({
          behavior: 'smooth'
        });
      },
      scrollTop(){
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        })
      },
      changeTab (a) {
        this.activeTab = a
      },
      async refresh (){
        this.activeTab = data.activeTab
        await setTimeout(this.refresh, 100)
      },
      AcceptCookie(){
            this.cookie = false;
      }
    }
  };
</script>

<style scoped>

a {
  color: #1B5E20;
}
.cookies{
      width: 500px;
      background-color: black;
      position:fixed;
      bottom: 2%;
      left: 2%;
}
.wrapper {
  width: 100%;
  font-size:0px;
  padding: 10px;
}
.column {
  display: inline-block;
  width: 33%;
  font-size:16px;
  margin: auto;
  text-align: center;
}
.text {
  color: black;
}
html {
  scroll-behavior: smooth;
}
#background{
  background-size: cover;
  background-attachment: fixed;
  width: auto;
  min-width: 900px;
  overflow:auto;
}

.background0{
  background-image: url("./assets/background/background1.jpg");
  animation-name: opacityBackground0Animation1;
  animation-duration: 30000ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}

.background1{
  background-image: url("./assets/background/background2.jpg");
  animation-name: opacityBackground1Animation1;
  animation-duration: 300000ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}

#opacityBackground{
  background: rgba(255, 255, 255, 0.5);
}

@keyframes opacityBackground0Animation {
  0%   { background-image: -webkit-cross-fade( 
        url('./assets/legitrans web/IMG_9250.jpg'), 
        url('./assets/legitrans web/20140908__D4N1058_385ab.jpg'),
        0%); }
  0.005%   { background-image: -webkit-cross-fade( 
        url('./assets/legitrans web/IMG_9250.jpg'), 
        url('./assets/legitrans web/20140908__D4N1058_385ab.jpg'),
        5%); }
  0.01%   { background-image: -webkit-cross-fade( 
        url('./assets/legitrans web/IMG_9250.jpg'), 
        url('./assets/legitrans web/20140908__D4N1058_385ab.jpg'),
        10%); }
  0.015%   { background-image: -webkit-cross-fade( 
        url('./assets/legitrans web/IMG_9250.jpg'), 
        url('./assets/legitrans web/20140908__D4N1058_385ab.jpg'),
        15%); }
  0.02%   { background-image: -webkit-cross-fade( 
        url('./assets/legitrans web/IMG_9250.jpg'), 
        url('./assets/legitrans web/20140908__D4N1058_385ab.jpg'),
        20%); }
  0.025%   { background-image: -webkit-cross-fade( 
        url('./assets/legitrans web/IMG_9250.jpg'), 
        url('./assets/legitrans web/20140908__D4N1058_385ab.jpg'),
        25%); }
  0.03%   { background-image: -webkit-cross-fade( 
        url('./assets/legitrans web/IMG_9250.jpg'), 
        url('./assets/legitrans web/20140908__D4N1058_385ab.jpg'),
        30%); }
  0.035%   { background-image: -webkit-cross-fade( 
        url('./assets/legitrans web/IMG_9250.jpg'), 
        url('./assets/legitrans web/20140908__D4N1058_385ab.jpg'),
        35%); }
  0.04%   { background-image: -webkit-cross-fade( 
        url('./assets/legitrans web/IMG_9250.jpg'), 
        url('./assets/legitrans web/20140908__D4N1058_385ab.jpg'),
        40%); }
  0.045%   { background-image: -webkit-cross-fade( 
        url('./assets/legitrans web/IMG_9250.jpg'), 
        url('./assets/legitrans web/20140908__D4N1058_385ab.jpg'),
        45%); }
  0.05%   { background-image: -webkit-cross-fade( 
        url('./assets/legitrans web/IMG_9250.jpg'), 
        url('./assets/legitrans web/20140908__D4N1058_385ab.jpg'),
        50%); }
  0.055%   { background-image: -webkit-cross-fade( 
        url('./assets/legitrans web/IMG_9250.jpg'), 
        url('./assets/legitrans web/20140908__D4N1058_385ab.jpg'),
        55%); }
  0.06%   { background-image: -webkit-cross-fade( 
        url('./assets/legitrans web/IMG_9250.jpg'), 
        url('./assets/legitrans web/20140908__D4N1058_385ab.jpg'),
        60%); }
  0.065%   { background-image: -webkit-cross-fade( 
        url('./assets/legitrans web/IMG_9250.jpg'), 
        url('./assets/legitrans web/20140908__D4N1058_385ab.jpg'),
        65%); }
  0.07%   { background-image: -webkit-cross-fade( 
        url('./assets/legitrans web/IMG_9250.jpg'), 
        url('./assets/legitrans web/20140908__D4N1058_385ab.jpg'),
        70%); }
  0.075%   { background-image: -webkit-cross-fade( 
        url('./assets/legitrans web/IMG_9250.jpg'), 
        url('./assets/legitrans web/20140908__D4N1058_385ab.jpg'),
        75%); }
  0.08%   { background-image: -webkit-cross-fade( 
        url('./assets/legitrans web/IMG_9250.jpg'), 
        url('./assets/legitrans web/20140908__D4N1058_385ab.jpg'),
        80%); }
  0.085%   { background-image: -webkit-cross-fade( 
        url('./assets/legitrans web/IMG_9250.jpg'), 
        url('./assets/legitrans web/20140908__D4N1058_385ab.jpg'),
        85%); }
  0.09%   { background-image: -webkit-cross-fade( 
        url('./assets/legitrans web/IMG_9250.jpg'), 
        url('./assets/legitrans web/20140908__D4N1058_385ab.jpg'),
        90%); }
  0.095%   { background-image: -webkit-cross-fade( 
        url('./assets/legitrans web/IMG_9250.jpg'), 
        url('./assets/legitrans web/20140908__D4N1058_385ab.jpg'),
        95%); }
  0.1%   { background-image: -webkit-cross-fade( 
        url('./assets/legitrans web/IMG_9250.jpg'), 
        url('./assets/legitrans web/20140908__D4N1058_385ab.jpg'),
        100%); }
  50%  { background-image: -webkit-cross-fade( 
        url('./assets/legitrans web/Legitrans2017AC.jpg'), 
        url('./assets/legitrans web/20140908__D4N1058_385ab.jpg'),
        100%); }
  99.005%  { background-image: -webkit-cross-fade( 
        url('./assets/legitrans web/Legitrans2017AC.jpg'), 
        url('./assets/legitrans web/20140908__D4N1058_385ab.jpg'),
        100%); }
  99.01%  { background-image: -webkit-cross-fade( 
        url('./assets/legitrans web/Legitrans2017AC.jpg'), 
        url('./assets/legitrans web/20140908__D4N1058_385ab.jpg'),
        95%); }
  99.015%  { background-image: -webkit-cross-fade( 
        url('./assets/legitrans web/Legitrans2017AC.jpg'), 
        url('./assets/legitrans web/20140908__D4N1058_385ab.jpg'),
        90%); }
  99.02%  { background-image: -webkit-cross-fade( 
        url('./assets/legitrans web/Legitrans2017AC.jpg'), 
        url('./assets/legitrans web/20140908__D4N1058_385ab.jpg'),
        85%); }
  99.025%  { background-image: -webkit-cross-fade( 
        url('./assets/legitrans web/Legitrans2017AC.jpg'), 
        url('./assets/legitrans web/20140908__D4N1058_385ab.jpg'),
        80%); }
  99.03%  { background-image: -webkit-cross-fade( 
        url('./assets/legitrans web/Legitrans2017AC.jpg'), 
        url('./assets/legitrans web/20140908__D4N1058_385ab.jpg'),
        75%); }
  99.035%  { background-image: -webkit-cross-fade( 
        url('./assets/legitrans web/Legitrans2017AC.jpg'), 
        url('./assets/legitrans web/20140908__D4N1058_385ab.jpg'),
        70%); }
  99.04%  { background-image: -webkit-cross-fade( 
        url('./assets/legitrans web/Legitrans2017AC.jpg'), 
        url('./assets/legitrans web/20140908__D4N1058_385ab.jpg'),
        65%); }
  99.045%  { background-image: -webkit-cross-fade( 
        url('./assets/legitrans web/Legitrans2017AC.jpg'), 
        url('./assets/legitrans web/20140908__D4N1058_385ab.jpg'),
        60%); }
  99.05%  { background-image: -webkit-cross-fade( 
        url('./assets/legitrans web/Legitrans2017AC.jpg'), 
        url('./assets/legitrans web/20140908__D4N1058_385ab.jpg'),
        55%); }
  99.055%  { background-image: -webkit-cross-fade( 
        url('./assets/legitrans web/Legitrans2017AC.jpg'), 
        url('./assets/legitrans web/20140908__D4N1058_385ab.jpg'),
        50%); }
  99.06%  { background-image: -webkit-cross-fade( 
        url('./assets/legitrans web/Legitrans2017AC.jpg'), 
        url('./assets/legitrans web/20140908__D4N1058_385ab.jpg'),
        45%); }
  99.065%  { background-image: -webkit-cross-fade( 
        url('./assets/legitrans web/Legitrans2017AC.jpg'), 
        url('./assets/legitrans web/20140908__D4N1058_385ab.jpg'),
        40%); }
  99.07%  { background-image: -webkit-cross-fade( 
        url('./assets/legitrans web/Legitrans2017AC.jpg'), 
        url('./assets/legitrans web/20140908__D4N1058_385ab.jpg'),
        35%); }
  99.075%  { background-image: -webkit-cross-fade( 
        url('./assets/legitrans web/Legitrans2017AC.jpg'), 
        url('./assets/legitrans web/20140908__D4N1058_385ab.jpg'),
        30%); }
  99.08%  { background-image: -webkit-cross-fade( 
        url('./assets/legitrans web/Legitrans2017AC.jpg'), 
        url('./assets/legitrans web/20140908__D4N1058_385ab.jpg'),
        25%); }
  99.085%  { background-image: -webkit-cross-fade( 
        url('./assets/legitrans web/Legitrans2017AC.jpg'), 
        url('./assets/legitrans web/20140908__D4N1058_385ab.jpg'),
        20%); }
  99.09%  { background-image: -webkit-cross-fade( 
        url('./assets/legitrans web/Legitrans2017AC.jpg'), 
        url('./assets/legitrans web/20140908__D4N1058_385ab.jpg'),
        15%); }
  99.095%  { background-image: -webkit-cross-fade( 
        url('./assets/legitrans web/Legitrans2017AC.jpg'), 
        url('./assets/legitrans web/20140908__D4N1058_385ab.jpg'),
        10%); }
  99.1%  { background-image: -webkit-cross-fade( 
        url('./assets/legitrans web/Legitrans2017AC.jpg'), 
        url('./assets/legitrans web/20140908__D4N1058_385ab.jpg'),
        5%); } 
  100.% { background-image: -webkit-cross-fade( 
        url('./assets/legitrans web/Legitrans2017AC.jpg'), 
        url('./assets/legitrans web/20140908__D4N1058_385ab.jpg'),
        0%); }
}

@keyframes opacityBackground0Animation1 {
  0%   { background-image: -webkit-cross-fade( 
        url('./assets/background/background2.jpg'), 
        url('./assets/background/background1.jpg'),
        50%); }
  0.01%   { background-image: -webkit-cross-fade( 
        url('./assets/background/background2.jpg'), 
        url('./assets/background/background1.jpg'),
        55%); }
  0.02%   { background-image: -webkit-cross-fade( 
        url('./assets/background/background2.jpg'), 
        url('./assets/background/background1.jpg'),
        60%); }
  0.03%   { background-image: -webkit-cross-fade( 
        url('./assets/background/background2.jpg'), 
        url('./assets/background/background1.jpg'),
        65%); }
  0.04%   { background-image: -webkit-cross-fade( 
        url('./assets/background/background2.jpg'), 
        url('./assets/background/background1.jpg'),
        70%); }
  0.05%   { background-image: -webkit-cross-fade( 
        url('./assets/background/background2.jpg'), 
        url('./assets/background/background1.jpg'),
        75%); }
  0.06%   { background-image: -webkit-cross-fade( 
        url('./assets/background/background2.jpg'), 
        url('./assets/background/background1.jpg'),
        80%); }
  0.07%   { background-image: -webkit-cross-fade( 
        url('./assets/background/background2.jpg'), 
        url('./assets/background/background1.jpg'),
        85%); }
  0.08%   { background-image: -webkit-cross-fade( 
        url('./assets/background/background2.jpg'), 
        url('./assets/background/background1.jpg'),
        90%); }
  0.09%   { background-image: -webkit-cross-fade( 
        url('./assets/background/background2.jpg'), 
        url('./assets/background/background1.jpg'),
        95%); }
  0.1%   { background-image: -webkit-cross-fade( 
        url('./assets/background/background2.jpg'), 
        url('./assets/background/background1.jpg'),
        100%); }
  50%  { background-image: -webkit-cross-fade( 
        url('./assets/background/background2.jpg'), 
        url('./assets/background/background1.jpg'),
        100%); }
  99.9%  { background-image: -webkit-cross-fade( 
        url('./assets/background/background2.jpg'), 
        url('./assets/background/background1.jpg'),
        100%); }
  99.91%  { background-image: -webkit-cross-fade( 
        url('./assets/background/background2.jpg'), 
        url('./assets/background/background1.jpg'),
        95%); }
  99.92%  { background-image: -webkit-cross-fade( 
        url('./assets/background/background2.jpg'), 
        url('./assets/background/background1.jpg'),
        90%); }
  99.93%  { background-image: -webkit-cross-fade( 
        url('./assets/background/background2.jpg'), 
        url('./assets/background/background1.jpg'),
        85%); }
  99.94%  { background-image: -webkit-cross-fade( 
        url('./assets/background/background2.jpg'), 
        url('./assets/background/background1.jpg'),
        80%); }
  99.95%  { background-image: -webkit-cross-fade( 
        url('./assets/background/background2.jpg'), 
        url('./assets/background/background1.jpg'),
        75%); }
  99.96%  { background-image: -webkit-cross-fade( 
        url('./assets/background/background2.jpg'), 
        url('./assets/background/background1.jpg'),
        70%); }
  99.97%  { background-image: -webkit-cross-fade( 
        url('./assets/background/background2.jpg'), 
        url('./assets/background/background1.jpg'),
        65%); }
  99.98%  { background-image: -webkit-cross-fade( 
        url('./assets/background/background2.jpg'), 
        url('./assets/background/background1.jpg'),
        60%); }
  99.99%  { background-image: -webkit-cross-fade( 
        url('./assets/background/background2.jpg'), 
        url('./assets/background/background1.jpg'),
        55%); } 
  100% { background-image: -webkit-cross-fade( 
        url('./assets/background/background2.jpg'), 
        url('./assets/background/background1.jpg'),
        50%); }
}

@keyframes opacityBackground1Animation1 {
  0%   { background-image: -webkit-cross-fade( 
        url('./assets/background/background1.jpg'), 
        url('./assets/background/background2.jpg'),
        50%); }
  0.01%   { background-image: -webkit-cross-fade( 
        url('./assets/background/background1.jpg'), 
        url('./assets/background/background2.jpg'),
        55%); }
  0.02%   { background-image: -webkit-cross-fade( 
        url('./assets/background/background1.jpg'), 
        url('./assets/background/background2.jpg'),
        60%); }
  0.03%   { background-image: -webkit-cross-fade( 
        url('./assets/background/background1.jpg'), 
        url('./assets/background/background2.jpg'),
        65%); }
  0.04%   { background-image: -webkit-cross-fade( 
        url('./assets/background/background1.jpg'), 
        url('./assets/background/background2.jpg'),
        70%); }
  0.05%   { background-image: -webkit-cross-fade( 
        url('./assets/background/background1.jpg'), 
        url('./assets/background/background2.jpg'),
        75%); }
  0.06%   { background-image: -webkit-cross-fade( 
        url('./assets/background/background1.jpg'), 
        url('./assets/background/background2.jpg'),
        80%); }
  0.07%   { background-image: -webkit-cross-fade( 
        url('./assets/background/background1.jpg'), 
        url('./assets/background/background2.jpg'),
        85%); }
  0.08%   { background-image: -webkit-cross-fade( 
        url('./assets/background/background1.jpg'), 
        url('./assets/background/background2.jpg'),
        90%); }
  0.09%   { background-image: -webkit-cross-fade( 
        url('./assets/background/background1.jpg'), 
        url('./assets/background/background2.jpg'),
        95%); }
  0.1%   { background-image: -webkit-cross-fade( 
        url('./assets/background/background1.jpg'), 
        url('./assets/background/background2.jpg'),
        100%); }
  50%  { background-image: -webkit-cross-fade( 
        url('./assets/background/background1.jpg'), 
        url('./assets/background/background2.jpg'),
        100%); }
  99.9%  { background-image: -webkit-cross-fade( 
        url('./assets/background/background1.jpg'), 
        url('./assets/background/background2.jpg'),
        100%); }
  99.91%  { background-image: -webkit-cross-fade( 
        url('./assets/background/background1.jpg'), 
        url('./assets/background/background2.jpg'),
        95%); }
  99.92%  { background-image: -webkit-cross-fade( 
        url('./assets/background/background1.jpg'), 
        url('./assets/background/background2.jpg'),
        90%); }
  99.93%  { background-image: -webkit-cross-fade( 
        url('./assets/background/background1.jpg'), 
        url('./assets/background/background2.jpg'),
        85%); }
  99.94%  { background-image: -webkit-cross-fade( 
        url('./assets/background/background1.jpg'), 
        url('./assets/background/background2.jpg'),
        80%); }
  99.95%  { background-image: -webkit-cross-fade( 
        url('./assets/background/background1.jpg'), 
        url('./assets/background/background2.jpg'),
        75%); }
  99.96%  { background-image: -webkit-cross-fade( 
        url('./assets/background/background1.jpg'), 
        url('./assets/background/background2.jpg'),
        70%); }
  99.97%  { background-image: -webkit-cross-fade( 
        url('./assets/background/background1.jpg'), 
        url('./assets/background/background2.jpg'),
        65%); }
  99.98%  { background-image: -webkit-cross-fade( 
        url('./assets/background/background1.jpg'), 
        url('./assets/background/background2.jpg'),
        60%); }
  99.99%  { background-image: -webkit-cross-fade( 
        url('./assets/background/background1.jpg'), 
        url('./assets/background/background2.jpg'),
        55%); } 
  100% { background-image: -webkit-cross-fade( 
        url('./assets/background/background1.jpg'), 
        url('./assets/background/background2.jpg'),
        50%); }
}
.comp{
  padding-top: 104px;
}

.pulse {
    animation-name: pulse_animation1;
    animation-duration: 5000ms;
    transform-origin:70% 70%;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
}
.opacity{
  display: block;

    -webkit-animation: opacity1 0.5s ease-out;
    -moz-animation: opacity1 0.5s ease-out;
    -o-animation: opacity1 0.5s ease-out;
    animation: opacity1 0.5s ease-out;
}

@keyframes pulse_animation1 {
  0% { transform: scale(1); }
  50% { transform: scale(1.2); }
  100% { transform: scale(1); }
}

@keyframes opacity1 {
  0% {
        display: none;
        opacity: 0;
    }

    1% {
        display: block;
        opacity: 0;
    }

    100% {
        display: block;
        opacity: 1;
    }
}



.float{
	position:fixed;
	width:60px;
	height:60px;
	bottom:40px;
	right:40px;
	background-color:#0C9;
	color:#FFF;
	border-radius:50px;
	text-align:center;
	box-shadow: 2px 2px 3px #999;
}

.text {
  fill: none;
  stroke-width: 1;
  stroke-linejoin: initial;
  stroke-width: 0.25px;
  stroke-dasharray: 70 250;
  stroke-dashoffset: 0;
  animation: stroke 48s infinite linear;
  width: 1000px;
}
.text:nth-child(4n + 1) {
  stroke: #DCEDC8;
  -webkit-animation-delay: -12s;
  animation-delay: -12s;
}
.text:nth-child(4n + 2) {
  stroke: #DCEDC8;
  -webkit-animation-delay: -24s;
  animation-delay: -24s;
}
.text:nth-child(4n + 3) {
  stroke: #DCEDC8;
  -webkit-animation-delay: -36s;
  animation-delay: -36s;
}
.text:nth-child(4n + 4) {
  stroke: #DCEDC8;
  -webkit-animation-delay: -48s;
  animation-delay: -48s;
}
@-webkit-keyframes stroke {
  100% {
    stroke-dashoffset: -320;
  }
}
@keyframes stroke {
  100% {
    stroke-dashoffset: -320;
  }
}

.titulo{
  width: 100%;
  min-width: 550px;
}
svg{
  width: 100%;
  height: 100%;
}


/* Scroll */
#style-2::-webkit-scrollbar-track
{
    border-radius: 10px;
    background-color: #F5F5F5;
}

#style-2::-webkit-scrollbar
{
    width: 12px;
    background-color: #F5F5F5;
}

#style-2::-webkit-scrollbar-thumb
{
    border-radius: 10px;
    background-color: #59476f;
}
</style>
